<template>

    <div class="room" @click="viewDetail(room.reference)">
        <div class="room__images">
            <div class="room__image__slider" :class="{ 'room-loading': !room.id }">
                <div class="room__image">
                    <img :src="room.images[0]" />
                </div>
            </div>
            <div class="room__actions" v-if="edit">
                <button class="btn btn-outline btn-outline--xsmall" @click="editListing(room.reference)"> EDIT</button>
                <button class="btn btn-outline btn-outline--xsmall" @click="viewDetail(room.reference)">
                    DETAILS</button>
                <button class="btn btn-outline btn-outline--xsmall"> CLOSE </button>
            </div>
            <span class="room__location shadow text-nowrap">{{ room.location }}</span>
        </div>
        <div v-if="room">
            <div class="mt-2 room__info" v-if="room.id">
                <span class="me-2 me-sm-3">
                    <svg width="13" height="13" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.8527 0.460845C13.853 -0.0624961 15.0653 0.0378274 15.9659 0.718469C16.6959 1.27017 17.125 2.13225 17.125 3.04728V9.70001V10.375H18.2696C19.5337 10.375 20.4356 11.6004 20.0599 12.8074L19.8787 13.3893C19.1515 15.725 17.615 17.7246 15.5453 19.0285L14.5011 19.6864C14.2018 19.875 13.8553 19.975 13.5016 19.975H7.3809C7.0416 19.975 6.70867 19.8829 6.41758 19.7086L4.7705 18.7223C2.74555 17.5096 1.19982 15.6368 0.393164 13.4187L0.201198 12.8908C-0.243507 11.668 0.662096 10.375 1.9633 10.375H15.775V9.70001V3.04728C15.775 2.55543 15.5444 2.09204 15.152 1.79549C14.6679 1.42963 14.0162 1.37571 13.4785 1.65701L13.2424 1.78057C12.5862 2.12387 12.175 2.80315 12.175 3.54368V4.00001H12.8876C12.9311 4.00001 12.9725 4.01892 13.001 4.05182L13.9101 5.10182C13.9942 5.19897 13.9252 5.35001 13.7967 5.35001H9.12864C9.00008 5.35001 8.93109 5.19886 9.01532 5.10173L9.92589 4.05173C9.95438 4.01888 9.99572 4.00001 10.0392 4.00001H10.825V3.54368C10.825 2.30074 11.5152 1.16061 12.6166 0.5844L12.8527 0.460845ZM1.9633 11.725C1.59896 11.725 1.34539 12.087 1.46991 12.4294L1.66187 12.9573C2.36255 14.884 3.70519 16.5108 5.46409 17.5641L7.11117 18.5504C7.19267 18.5992 7.28589 18.625 7.3809 18.625H13.5016C13.6007 18.625 13.6977 18.597 13.7815 18.5442L14.8256 17.8863C16.6234 16.7537 17.9581 15.0168 18.5897 12.988L18.7709 12.4061C18.8761 12.0681 18.6236 11.725 18.2696 11.725H1.9633ZM4.75001 6.77501C4.75001 7.23064 4.38065 7.60001 3.92501 7.60001C3.46938 7.60001 3.10001 7.23064 3.10001 6.77501C3.10001 6.31937 3.46938 5.95001 3.92501 5.95001C4.38065 5.95001 4.75001 6.31937 4.75001 6.77501ZM1.60001 6.40001C1.84854 6.40001 2.05001 6.19853 2.05001 5.95001C2.05001 5.70148 1.84854 5.50001 1.60001 5.50001C1.35149 5.50001 1.15001 5.70148 1.15001 5.95001C1.15001 6.19853 1.35149 6.40001 1.60001 6.40001ZM4.00001 4.45001C4.00001 4.61569 3.8657 4.75001 3.70001 4.75001C3.53433 4.75001 3.40001 4.61569 3.40001 4.45001C3.40001 4.28432 3.53433 4.15001 3.70001 4.15001C3.8657 4.15001 4.00001 4.28432 4.00001 4.45001ZM10.225 6.10001C10.225 5.93432 10.0907 5.80001 9.92501 5.80001C9.75933 5.80001 9.62501 5.93432 9.62501 6.10001V7.60001C9.62501 7.76569 9.75933 7.90001 9.92501 7.90001C10.0907 7.90001 10.225 7.76569 10.225 7.60001V6.10001ZM13 5.95001C13.1657 5.95001 13.3 6.08432 13.3 6.25001V7.75001C13.3 7.91569 13.1657 8.05001 13 8.05001C12.8343 8.05001 12.7 7.91569 12.7 7.75001V6.25001C12.7 6.08432 12.8343 5.95001 13 5.95001ZM11.8 7.60001C11.8 7.43432 11.6657 7.30001 11.5 7.30001C11.3343 7.30001 11.2 7.43432 11.2 7.60001V9.10001C11.2 9.26569 11.3343 9.40001 11.5 9.40001C11.6657 9.40001 11.8 9.26569 11.8 9.10001V7.60001Z"
                            fill="#000" />
                    </svg>
                    <span class="ms-1" v-if="room.ensuite === true"> Ensuite</span> <span v-if="room.ensuite === false">
                        Shared ensuite</span>
                </span>
                <span>
                    <svg width="13" height="13" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M1.90002 0.84317C0.864491 0.84317 0.0250244 1.68264 0.0250244 2.71817V8.90605C0.0250244 8.92074 0.0251933 8.93538 0.0255291 8.94999H1.37684C1.37564 8.9355 1.37502 8.92085 1.37502 8.90605V2.71817C1.37502 2.42822 1.61007 2.19317 1.90002 2.19317H18.25C18.54 2.19317 18.775 2.42822 18.775 2.71817V8.90605C18.775 8.92085 18.7744 8.9355 18.7732 8.94999H20.1245C20.1249 8.93538 20.125 8.92074 20.125 8.90605V2.71817C20.125 1.68264 19.2856 0.84317 18.25 0.84317H1.90002ZM10.975 6.24999C10.975 5.21446 11.8145 4.37499 12.85 4.37499H16C17.0356 4.37499 17.875 5.21446 17.875 6.24999V8.34999V9.02499H17.2H11.65H10.975V8.34999V6.24999ZM12.85 5.72499C12.5601 5.72499 12.325 5.96004 12.325 6.24999V7.67499H16.525V6.24999C16.525 5.96004 16.29 5.72499 16 5.72499H12.85ZM0.0250244 12.25C0.0250244 11.2145 0.864491 10.375 1.90002 10.375H18.25C19.2856 10.375 20.125 11.2145 20.125 12.25V16.15C20.125 17.1855 19.2856 18.025 18.25 18.025H17.95V19.9H16.6V18.025H3.40002V19.9H2.05002V18.025H1.90002C0.864491 18.025 0.0250244 17.1855 0.0250244 16.15V12.25ZM1.90002 11.725C1.61007 11.725 1.37502 11.96 1.37502 12.25V14.2H18.775V12.25C18.775 11.96 18.54 11.725 18.25 11.725H1.90002ZM18.775 15.7H1.37502V16.15C1.37502 16.4399 1.61008 16.675 1.90002 16.675H18.25C18.54 16.675 18.775 16.4399 18.775 16.15V15.7ZM3.85002 4.52499C2.81449 4.52499 1.97502 5.36446 1.97502 6.39999V8.49999V9.17499H2.65002H8.20002H8.87502V8.49999V6.39999C8.87502 5.36446 8.03556 4.52499 7.00002 4.52499H3.85002ZM3.32502 6.39999C3.32502 6.11004 3.56008 5.87499 3.85002 5.87499H7.00002C7.28997 5.87499 7.52502 6.11004 7.52502 6.39999V7.82499H3.32502V6.39999Z"
                            fill="#000" />
                    </svg>
                    <span class="ms-1"> {{ room.beds }} bed(s)</span>
                </span>
            </div>
            <p class="room__price mt-2" v-if="editRoom === false && room.price">
                {{ $filters.currency(listingPrice, room.currencyCode) }}<small class="text-muted">/{{
                    $filters.billing(computedBillingRate) }}</small>
            </p>
            <p class="room__price mt-2" v-if="editRoom === true && room.price">
                {{ $filters.currency(room.price, room.currencyCode) }} <small class="text-muted">/{{
                    $filters.billing(computedBillingRate) }}</small>
            </p>
            <p class="mb-0" v-if="editRoom === true">
                #{{ room.reference }}
            </p>
            <p class="room__lite_price" v-if="room.status === 0">
                <span class="available">{{ room.availability }}</span>
            </p>
        </div>
    </div>

</template>

<script>
export default {
    data: function () {
        return {
            editRoom: false
        }
    },
    props: {
        room: {
            type: Object,
            required: true
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.edit) {
            this.editRoom = true;
        }
    },
    computed: {
        listingPrice() {
            if (this.room.billingRate === 5) {
                //Todo: Ugo: put rates in a config
                let price = this.room.price;
                let serviceCharge = this.room.serviceCharge ?? 0.00;
                let cautionFee = this.room.cautionFee ?? 0.00;
                let legalFee = this.room.legalFee ?? 0.00;
                let agencyFee = this.room.agencyFee ?? 0.00;
                let subscriptionFee = this.$filters.subscriptionFee(this.room.price);                                 
                let total = (price + serviceCharge + cautionFee + legalFee + agencyFee + subscriptionFee);                
                let totalRepayment = ((total * 20.4 *1)/100) + total;
                let montlyRepayment = totalRepayment / 12;
                let raveFee = this.$filters.raveFee(montlyRepayment);
                return montlyRepayment + raveFee;
            }
            return this.$filters.includeFee(this.room.price);
        },
        computedBillingRate(){
            if (this.room.billingRate === 5) { // if the billing rate is yearly, display monthly
                return 2;
            }
            return this.room.billingRate;
        },
    },
    methods: {
        viewDetail(ref) {
            if (this.editRoom !== true) {
                let routeData = this.$router.resolve({ path: `/listing/detail/${ref}` });
                window.open(routeData.href, '_blank');
            }
        },
        editListing(ref) {
            this.$router.push({ path: `/listing/${ref}/edit` });
        },
        closeRoom(ref) { }
    },
    directives: {
        image: {
            bind(el, binding) {
                el.style.cssText = 'background: url(' + binding.value + ') no-repeat center center; background-size:cover';
            }
        }
    }
}
</script>
<style scoped>
.room {
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    min-width: 135px;
}

@media (min-width: 768px) {
    .room:last-of-type {
        margin-right: 0;
    }
}

@media (min-width: 768px) {
    .room {
        flex: 1;
    }
}

@media (min-width: 1200px) {
    .room {
        margin-right: 24px;
    }
}

.room__see-more {
    border-radius: 8px;
    background: #F4C0D4;
    height: 135px;
}

.room__see-more__text {
    line-height: 13.63px;
}

.room__see-more__link {
    background: #fff;
    color: #E81865;
    border-radius: 4px;
    font-weight: 600;
}

.room .room__images {
    position: relative;
    width: 100%;
}

.room .room__images .room__location {
    padding: 3px 6px;
    background-color: #ffffff;
    font-weight: 400;
    font-size: 10px;
    color: #333333;
    position: absolute;
    bottom: 6%;
    left: 20px;
    border-radius: 5px;
    max-width: 78px;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (min-width: 575.98px) {
    .room .room__images .room__location {
        font-size: 13px;
        padding: 3px 10px;
    }
}

@media (min-width: 768px) {
    .room .room__images .room__location {
        max-width: 135px;
    }
}

@media (min-width: 992px) {
    .room .room__images .room__location {
        max-width: none;
        overflow: auto;
        text-overflow: initial;
    }
}

.room .room__images .room__actions {
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    bottom: 50%;
    text-align: center;
    width: 100%;
    padding: 10px;
}

.room .room__images .room__image__slider {
    width: 100%;
    height: 135px;
    position: relative;
    /*background: url('https://via.placeholder.com/390x240/') no-repeat center center;*/
    background-size: cover;
    position: relative;
}

@media (min-width: 575.98px) {
    .room .room__images .room__image__slider {
        height: 215px;
    }
}

@media (min-width: 1400px) {
    .room .room__images .room__image__slider {
        height: 304px;
    }
}

.room .room__images .room__image__slider .room__image {
    width: 100%;
    height: 100%;
    position: relative;
}

.room .room__images .room__image__slider .room__image img {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.room .room__images .room__image__slider.room-loading {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.room .room__price {
    text-align: left;
    margin-top: .9rem;
    margin-bottom: 3px;
    font-weight: 600;
    font-size: 13px;

    max-width: 135px;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (min-width: 575.98px) {
    .room .room__price {
        font-size: 14px;
    }
}

@media (min-width: 768px) {
    .room .room__price {
        font-size: 16px;
        max-width: none;
    }
}

@media (min-width: 992px) {
    .room .room__price {
        overflow: auto;
        text-overflow: initial;
    }
}

.room .room__lite_price {
    text-align: left;
    font-weight: 400;
    font-size: 10px;

    color: rgba(0, 0, 0, 0.7);
    display: inline-block;
    border: 0.8px solid #E81865;
    border-radius: 4px;
    color: #E81865;
    padding: 0.125rem 0.5rem;
    margin-top: 2px;
}

@media (min-width: 575.98px) {
    .room .room__lite_price {
        margin-top: 4px;
    }
}

.room .room__lite_price.rented {
    color: #fff;
    background: #778080;
    border: 0.3px solid #778080;
    border-radius: 4px;
}

@media (min-width: 575.98px) {
    .room .room__lite_price {
        font-size: 14px;
    }
}

.room .room__info {
    font-size: 10px;
}

@media (min-width: 575.98px) {
    .room .room__info {
        font-size: 13px;
    }
}
</style>